module.exports = __webpack_public_path__ + "static/img/u222_02.b8890d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u222_02.jpg
// module id = 7jrL
// module chunks = 0